<template>

  <div>
    <b-overlay
      id="overlay-background"
      :show="loader === true"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <b-card
        no-body
      >

        <div class="m-2">

          <!-- Table Top -->
          <b-row>
            <b-alert
              v-if="errorMsg"
              variant="warning"
              class="w-100"
              show
            >
              <div class="alert-body">
                <span>{{ errorMsg }}</span>
              </div>
            </b-alert>
          </b-row>
          <b-row>
            <label
              for="extension"
              class="mt-1"
            >File</label>
            <b-form-file
              ref="payment-file"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
              @change="fileInserted($event)"
            />
          </b-row>
        </div>
      </b-card>
      <!-- Table Container Card -->
      <b-card
        no-body
        class="mb-0"
      >

        <div class="m-2">

          <!-- Table Top -->
          <b-row>

            <!-- Per Page -->
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>{{ $t('DEBTIA_SHOW') }}</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
              />
              <label>{{ $t('DEBTIA_ENTRIES') }}</label>
            </b-col>
          </b-row>

        </div>

        <b-table
          ref="refUserListTable"
          class="position-relative"
          :items="paymentsList"
          responsive
          :fields="tableColumns"
          selectable
          :select-mode="selectMode"
          primary-key="id"
          show-empty
          empty-text="No matching records found"
          @row-selected="onRowSelected"
        >
          <template #cell(file_name)="data">
            <b-button
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="outline-secondary"
              @click="downloadFile(constants.serverBaseUrl, data.item.file_address, data.item.file_name)"
            >
              {{ data.item.file_name }}
            </b-button>
          </template>
          <template #cell(effected_cases)="data">
            <b-badge
              variant="light-info"
            >
              {{ data.item.effected_cases }}
            </b-badge>
          </template>
          <template #cell(status)="data">
            <b-badge
              :variant="data.item.status === 'Imported' ? 'light-success' : 'light-danger'"
            >
              {{ data.item.status }}
            </b-badge>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">{{ $t('DEBTIA_SHOW') }} {{ from }} {{ $t('DEBTIA_TO') }} {{ to }} {{ $t('DEBTIA_OF') }} {{ totalPages }} {{ $t('DEBTIA_ENTRIES') }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >

              <b-pagination
                v-model="currentPage"
                :total-rows="totalPages"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
      </b-card>
      <payments-breakdown-modal
        ref="payments-breakdown-modal"
        :entries="entries"
        :get-list="getList"
        :client-id="client_id"
        :secret-id="secret_id"
      />
    </b-overlay></div>
</template>

<script>
import {
  BCard, BRow, BCol, BButton, BTable, BPagination, BOverlay, BBadge, BFormFile, BAlert,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import i18n from '@/libs/i18n'
// import store from '@/store'
import constants from '@/app-configs/constants'
import Ripple from 'vue-ripple-directive'
import axios from '@axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import PaymentsBreakdownModal from './PaymentsBreakdownModal.vue'

export default {
  components: {
    // UsersListFilters,

    BCard,
    BRow,
    BCol,
    BButton,
    BTable,
    BPagination,
    BBadge,
    vSelect,
    BOverlay,
    BFormFile,
    BAlert,
    PaymentsBreakdownModal,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      errorMsg: null,
      loader: false,
      client_id: '',
      secret_id: '',
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      searchQuery: '',
      totalPages: 0,
      from: 0,
      to: 0,
      currentPage: 1,
      paymentsList: [],
      tableColumns: [
        { key: 'employee_name', sortable: true, label: i18n.t('DEBTIA_EMPLOYEE') },
        { key: 'posting_date', sortable: true, label: i18n.t('DEBTIA_UPLOADING_DATE') },
        { key: 'file_name', sortable: true, label: i18n.t('DEBTIA_FILE') },
        {
          key: 'entries', sortable: false, label: i18n.t('DEBTIA_ENTRIES'), class: 'text-center',
        },
        {
          key: 'effected_cases', label: i18n.t('DEBTIA_AFFECTED_CASES'), class: 'text-center',
        },
        { key: 'status', label: i18n.t('DEBTIA_STATUS') },
      ],
      entries: [],
      selectMode: 'single',
      constants,
    }
  },
  watch: {
    currentPage: {
      handler() {
        this.getList()
      },
    },
    perPage: {
      handler() {
        this.currentPage = 1
        this.getList()
      },
    },
  },
  created() {
    this.caseCredentials()
    this.actionColumn()
    // this.getList()
  },
  methods: {
    onRowSelected(item) {
      // this.selected = item
      if (item['0'].status === 'Pending') {
        this.$router.push({ name: 'payments-breakdown-id', params: { id: item['0'].id } })
      }
    },
    downloadFile(url, address, name) {
      const link = document.createElement('a')
      link.style.display = 'none'

      // Set the link's href to the file link
      link.href = url + address

      // Set the download attribute to specify the filename
      link.download = name

      // Append the link to the document
      document.body.appendChild(link)

      // Simulate a click on the link to trigger the download
      link.click()

      // Remove the link from the document
      document.body.removeChild(link)
    },
    setValues(element) {
      const account = element.account.toLowerCase()
      if (account !== '' && account !== 'skat retur') {
        const accountArr = account.split(':')
        // eslint-disable-next-line no-param-reassign
        element.paymentAccountType = 'case'
        // eslint-disable-next-line no-param-reassign, prefer-destructuring
        element.searchQuery = accountArr[1]
      } else if (account !== '' && account === 'SKAT RETUR') {
        // eslint-disable-next-line no-param-reassign
        element.paymentAccountType = 'SKAT RETUR'
        // eslint-disable-next-line no-param-reassign, prefer-destructuring
        element.searchQuery = ''
      }
    },
    async fileInserted(data) {
      this.loader = true
      const form = new FormData()
      let file = null
      let type = null
      try {
        // Code that may throw an error
        // eslint-disable-next-line prefer-destructuring
        file = data.target.files[0]
        type = file.type
        // this.throwError()
      } catch (error) {
        // Handle the error
        data.dataTransfer.items.forEach(async item => {
        // If dropped items aren't files, reject them
          if (item.kind === 'file') {
            file = item.getAsFile()
            type = file.type
          }
        })
      }
      if (type.indexOf('csv') !== -1) {
        form.append('file', file)
        const fileUpload = await axios.post('/payment-interface/files/upload', form, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        // this.loader = false
        if (fileUpload.status) {
          const records = fileUpload.data.paymentInterfaceEntries
          if (records.length > 0) {
            records.forEach(element => {
              // let accountArr = []
              // if (element.account && (element.account !== '' && element.account !== 'SKAT RETUR')) {
              //   accountArr = element.account.split(':')
              // }
              // eslint-disable-next-line no-param-reassign
              element.searchQuery = null
              // eslint-disable-next-line no-param-reassign
              element.isDropdownVisible = false
              // eslint-disable-next-line no-param-reassign
              element.recordSearch = false
              // eslint-disable-next-line no-param-reassign
              element.paymentAccountType = null
              // eslint-disable-next-line no-param-reassign
              element.caseNotSelected = false
              // eslint-disable-next-line no-param-reassign
              element.accountOptions = []
              if (element.account) {
              // eslint-disable-next-line no-param-reassign
                element.accountOptions.unshift(...fileUpload.data.caseEntries)
                // element.accountOptions.unshift({
                //   value: accountArr[0], label: accountArr[1],
                // })
              }
              this.setValues(element)
            })
            this.entries = records
            localStorage.setItem('paymententries', JSON.stringify(this.entries))
            this.$router.push({ name: 'payments-breakdown' })
            this.loader = false
            this.errorMsg = null
          } else {
            this.loader = false
            this.errorMsg = 'Data could not be fetched from file.'
            localStorage.setItem('paymententries', JSON.stringify([]))
            this.$refs['payment-file'].reset()
          }
        }
      } else {
        this.loader = false
        this.$refs['payment-file'].reset()
        this.errorMsg = 'Please intesrt a CSV file.'
      }
    },
    actionColumn() {
      if (this.$ability.cannot(constants.action.permissionUserEdit, constants.resource.user) && this.$ability.cannot(constants.action.permissionUserDelete, constants.resource.user)) {
        this.tableColumns.splice(4)
      }
    },
    confirmText(id) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          axios.post('/users/delete-user', { id })
            .then(response => {
              this.refetchData()
              this.$swal({
                icon: 'success',
                title: 'Deleted!',
                text: response.data.message,
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              })
            })
        }
      })
    },
    async caseCredentials() {
      this.loader = true
      axios.get('user-settings/get', { params: { module: 'debt-cases' } }).then(response => {
        const settingDetails = response.data.data
        if (settingDetails === null) {
          this.client_id = ''
          this.secret_id = ''
          this.loader = false
        } else {
          this.client_id = settingDetails.client_id
          this.secret_id = settingDetails.secret
          this.getList()
          this.loader = false
        }
      }).catch(error => {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Setting Management',
            icon: 'CoffeeIcon',
            variant: 'danger',
            text: error.response.data.message,
          },
        })
        this.loader = false
      })
    },
    async getList() {
      this.loader = true
      const list = await axios.get(`/payment-interface/files/get?per_page=${this.perPage}&page=${this.currentPage}`, {
        headers: {
          secret: this.secret_id,
          clientId: this.client_id,
        },
      })
      // this.loader = false
      if (list.status) {
        this.paymentsList = list.data.data.data
        this.totalPages = list.data.data.total
        this.from = list.data.data.from
        this.to = list.data.data.to
        this.currentPage = list.data.data.current_page
        this.loader = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
